import { useMutation } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'

export interface CreateMarketShopPaymentRequest {
  sessionId: string
}

export interface CreateMarketShopPaymentResponse {
  clientSecret: string
}

export const createMarketShopPayment = async (data: CreateMarketShopPaymentRequest) => {
  const response = await marketShopAPI.post<CreateMarketShopPaymentResponse>(
    `/market-shop/pay`,
    data,
  )
  return response.data
}

export const useCreateMarketShopPayment = () => {
  return useMutation({
    mutationFn: createMarketShopPayment,
  })
}
